"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearValue = exports.setError = exports.setSuccess = exports.updateResponse = exports.setPolling = exports.setRefreshing = exports.setFetchingNextPage = exports.setPending = exports.normalizedGet = void 0;
var variant_1 = require("./variant");
var unknownStoreValue = {
    variant: { status: variant_1.Status.Unknown },
    metadata: {},
};
exports.normalizedGet = function (store, key) {
    return store.get(key) || unknownStoreValue;
};
var updateExisting = function (store, key, variant, metadata) {
    if (metadata === void 0) { metadata = {}; }
    var existingState = exports.normalizedGet(store, key);
    var newState = {
        variant: __assign(__assign({}, existingState.variant), variant),
        metadata: __assign(__assign({}, existingState.metadata), metadata),
    };
    store.put(key, newState);
};
exports.setPending = function (store, key) {
    store.put(key, {
        variant: { status: variant_1.Status.Pending },
        metadata: { lastFetchTime: Date.now() },
    });
};
exports.setFetchingNextPage = function (store, key) {
    return updateExisting(store, key, { status: variant_1.Status.Pending });
};
exports.setRefreshing = function (store, key) {
    return updateExisting(store, key, { status: variant_1.Status.Refreshing }, { lastFetchTime: Date.now() });
};
exports.setPolling = function (store, key) {
    return updateExisting(store, key, { status: variant_1.Status.Polling }, { lastFetchTime: Date.now() });
};
exports.updateResponse = function (store, key, response) { return updateExisting(store, key, { result: response }); };
exports.setSuccess = function (store, key, response) {
    return updateExisting(store, key, {
        result: response,
        status: variant_1.Status.Success,
        error: undefined,
    });
};
exports.setError = function (store, key, error) {
    updateExisting(store, key, { error: error, status: variant_1.Status.Error });
};
exports.clearValue = function (store, key) {
    return store.put(key, undefined);
};
//# sourceMappingURL=connectorStore.js.map